"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.InputCSS = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _inputSizes = _interopRequireDefault(require("./inputSizes.css"));

var _inputStates = _interopRequireDefault(require("./inputStates.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  outline: none;\n  padding: .8em 1em;\n  font-size: 0.9em;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  &::placeholder {\n    color: ", ";\n  }\n  &[type=\"checkbox\"] {\n    margin: 0;\n    padding: 0;\n    max-height: 18px;\n    max-width: 18px;\n  }\n  &[type=\"date\"] {\n    height: 36px;\n    padding: 4px;\n  }\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var InputCSS = (0, _styledComponents.css)(_templateObject(), function (props) {
  return props.width || '100%';
}, function (props) {
  return props.theme.colors.white['500'];
}, function (props) {
  return props.theme.colors.gray['900'];
}, _inputStates["default"], _inputSizes["default"]);
exports.InputCSS = InputCSS;

var Input = _styledComponents["default"].input(_templateObject2(), InputCSS);

var _default = Input;
exports["default"] = _default;